import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AccountINFORPO, _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectAvailableTaxEntityConsecutive } from "./Selectores/SelectAvailableTaxEntityConsecutive";
import { toast } from "react-toastify";
import { Alert } from "../../../../../theme/Component/Alert";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";


interface Props {
    _idUBLInvoice: number;
    _isseDate: string;
    _obs?:string;
    _refresh?: () => void;
}

interface form {
    SoftwareDispatcher: number;
    TaxEntity: number;
    SoftwareName: string;
}

export const FireElectronicDocument = ({ _idUBLInvoice, _isseDate, _obs, _refresh }: Props) => {

    const _invoice = useDataBean(_UBLInvoice);
    const _account = useDataBean(_AccountINFORPO);
    const { instance: rawInstance, bean, setBean, lista, setLista } = _invoice;
    const instance = rawInstance as any;
    const [response, setResponse] = useState<form>({
        SoftwareDispatcher: null,
        TaxEntity: null,
        SoftwareName: "",
    })
    const [document, setDocument] = useState<any>({});
    const [documentPdf, setDocumentPdf] = useState<any>({});
    const [documentResponse, setDocumentResponse] = useState<any>({});
    const [invoice, setInvoice] = useState<any>({
        UUID:''
    });
    const [adquiriente,setAdquiriente] = useState<any>({
        
        
    });
    const [notes, setNotes] = useState<string[]>(() => {
        if (_obs) {
            try {
                const parsed = JSON.parse(_obs);
                if (Array.isArray(parsed)) {
                    return parsed.map(String);
                }
            } catch (e) {
                if (_obs.includes("\n")) {
                    return _obs.split("\n").map(n => n.trim()).filter(Boolean);
                }
                return [_obs];
            }
        }
        return [""];
    });
    const [currentNote, setCurrentNote] = useState<string>("");
    const [emails, setEmails] = useState("");
    const [siif, setSIFF] = useState<boolean>(false);
    const [lineOfBusiness, setLineOfBusiness] = useState<string>("");

    const addNote = () => {
        if (currentNote.trim() !== "") {
            setNotes(prev => [...prev, currentNote.trim()]);
            setCurrentNote("");
        } else {
            toast.warning("La nota no puede estar vacía");
        }
    };

    const removeNote = (index: number) => {
        setNotes(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        getSoftware();
        setLista([]);
        
    }, [])
    useEffect(() => {
       getInvoice();            
    }, [_idUBLInvoice,_isseDate])

    useEffect(() => {
        if (_obs && _obs.trim() !== "") {
            try {
                const parsed = JSON.parse(_obs);
                if (Array.isArray(parsed)) {
                    setNotes(parsed.map(String).filter(n => n.trim() !== ""));
                    return;
                }
            } catch (e) {
                if (_obs.includes("\n")) {
                    setNotes(_obs.split("\n").map(n => n.trim()).filter(Boolean));
                    return;
                }
                setNotes([_obs.trim()]);
                return;
            }
        } else {
            setNotes([]);
        }
    }, [_obs]);

 

    const getInvoice =()=>{
        if(_idUBLInvoice && _isseDate)
        {
            _invoice.instance.getUblInvoice(_idUBLInvoice,_isseDate).then(
                    (resp: any) => {
                        
                        setInvoice(resp);
                        if(resp.IDAccountCustomer){
                        _account.instance.getAccount(resp.IDAccountCustomer).then(
                            (respAccount: any) => {
                                
                                setAdquiriente(respAccount);
                                if(respAccount.eMail){
                                    setEmails(respAccount.eMail);
                                }

                            }
                        ).catch(er => { toast.error(er) })
                    }
                }
                ).catch(er => { toast.error(er) })

        }else{
            setInvoice({UUID:''});
        }
    }

    const joinNotes =()=>{
        let note = "";
        notes.forEach((n: string) => {
            note += n + "\n";
        })
        return [note.trim()];
    }

    const fireElectronicDocument = () => {

        if (!response.SoftwareDispatcher || !response.TaxEntity) {
            toast.error("Tiene que llenar todos los datos")
            return;
        }

        const apiCall = instance.fireElectronicDocumentNotes(_idUBLInvoice, _isseDate, _single.getAccountID(), response.SoftwareDispatcher, response.TaxEntity, joinNotes());            
        apiCall.then(
            (resp: any) => {
                
                let x = resp;
                if (x.AplicationResponse) {
                    setDocumentResponse(x.AplicationResponse.DataBeanProperties ? x.AplicationResponse.DataBeanProperties : {});
                }
                if (x.InvoicePDF) {
                    setDocumentPdf(x.InvoicePDF.DataBeanProperties ? x.InvoicePDF.DataBeanProperties : {});
                }
                if (x.ZipFile) {
                    setDocument(x.ZipFile ? x.ZipFile.DataBeanProperties : {});
                    x.LinkURL = `<a href="${x.ZipFile.DataBeanProperties.URL}" target='_blank'>${x.ZipFile.DataBeanProperties.Filename ? x.ZipFile.DataBeanProperties.Filename : "Archivo a descargar"}</a>`
                } else {
                    x.LinkURL = "N/A"
                }
                setBean(resp);
                if (resp.ResponseList && resp.ResponseList.length > 0) {
                    setLista(resp.ResponseList)
                }
                getInvoice();
            }
        ).catch((err: any) => {
            console.log(err)
            toast.error(err)
        })
    }

    const sendMail = () => {
        
        
        if(siif){
            if(lineOfBusiness =='' || emails=='')
            {
                toast.error("Linea de Negocio y Correos son obligatorios")
                return;
            }
        }

            const props = {
                message: notes.join("\n"),
                mail:emails,
                siif:siif,
                BusinessLine:lineOfBusiness
            }
            instance.notifyInvoiceEmail(_single.getAccountID(), _idUBLInvoice, _isseDate, props).then(
            (resp: any) => {
                console.log(resp.OK);
                if (resp.OK) {
                    toast.success(resp.OK)
                }
                else if (resp.ERR) {
                    toast.warning(resp.ERR)
                }
                else {
                    toast.error("")
                };                   
            }
        ).catch((err: any) => { toast.error(err) })
      

    }


    const getSoftware = () => {
        instance.getUBLSoftwareDispatcherByEnvironmentType(null).then(
            (resp: any) => {
                setResponse((prev: any) => ({
                    ...prev,
                    SoftwareDispatcher: resp.IDUBLSoftwareDispatcher,
                    SoftwareName: resp.SoftwareName
                }));
            }
        ).catch(er => { toast.error(er) })
    }

    const head2 = [
        { title: 'ID', property: 'LineID', visible: true },
        { title: 'Codigo de Respuesta', property: 'ResponseCode', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    return (
        <div className="row">
            <div className="col-md-4">
                <label>Software de Facturación</label>
                <input disabled type="text" className="form-control" value={response.SoftwareDispatcher ? `${response.SoftwareDispatcher} - ${response.SoftwareName}` : ""} />
            </div>
            <div className="col-md-8">
                <SelectAvailableTaxEntityConsecutive ubl={{ IDUBLInvoice: _idUBLInvoice, IssueDate: _isseDate }} idSelect={response.TaxEntity} onChange={(e) => { setResponse((prev: any) => ({ ...prev, "TaxEntity": e })) }} />
            </div>
            <div className="col-md-12">
                {((invoice?.UUID && invoice?.StatusMessage  && invoice?.StatusMessage.includes("ha sido autorizada")) ) && 
                <Alert clase="primary">
                    <p className="text-break">
                        
                        {invoice.StatusMessage}: CUFE:{invoice.UUID}
                    </p>

                </Alert>
                
                }
                {/* <PrintJson json={invoice}/> */}
            </div>
           
            {!invoice.UBLDispatched &&
                <>
                <div className="col-md-12">
                    <label>Notas</label>
                    <div className="card mb-3 border">
                        <div className="card-body p-3">
                            {notes.length === 0 ? (
                                <p className="text-muted mb-2 font-size-13">No hay notas agregadas.</p>
                            ) : (
                                <ul className="list-group list-group-flush mb-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                                    {notes.map((note, index) => (
                                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center p-2">
                                            <span className="text-break font-size-13">{note}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-outline-danger btn-sm border-0 py-0 px-2"
                                                onClick={() => removeNote(index)}
                                                title="Eliminar nota"
                                            >
                                                <i className="ri-delete-bin-line"></i>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        
                            
                                <div className="mt-2">
                                    <textarea 
                                        className="form-control mb-2" 
                                        placeholder="Escribe una nota..."
                                        value={currentNote}
                                        onChange={(e) => setCurrentNote(e.target.value)}
                                        rows={2}
                                    />
                                    <div className="d-flex justify-content-end">
                                        <BasicButton 
                                            
                                            icon="ri-add-line" 
                                            eventClick={addNote}
                                            clase="success"
                                        >
                                            Agregar Nota
                                        </BasicButton>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                    {/* <PrintJson json={adquiriente}/> */}
                </div>
                <div className="col-md-12">
                    <BasicButton useMargin eventClick={() => { fireElectronicDocument() }} icon="ri-send-plane-line" children={`Transmitir`} />
                </div>
                </>
            }
            
             <div className="col-md-12">
                <hr />
                <label> Correos</label>
                <input type="text" className="form-control" value={emails ?? ""} onChange={(e) => { setEmails(e.target.value) }} />
                <small>(Separados por coma (,) )</small>
            </div>
            <div className="col-md-12">
                <BasicSwitch label="Enviar notificación a SIIF" estado={siif} eventChange={(e) => { setSIFF(e) }} /> 
            </div>  
            <div className="col-md-12">
                {siif && 
                <>
                    <label>Linea de negocio</label>
                    <input type="text" className="form-control" value={lineOfBusiness} onChange={(e) => { setLineOfBusiness(e.target.value) }} />
                </>
                }
            </div>
            
    
           
            <div className="col-md-4">
                <BasicButton 
                disable={!invoice.UBLDispatched } 
                useMargin eventClick={() => { sendMail() }} icon="ri-send-plane-line" children={`Notificar  `} />
            </div>

            <div className="col-md-12">
                {bean.LinkURL &&
                    <div className="row">
                        <div className="col-md-12">

                            <Alert clase={bean.IsValid == false ? "warning" : "success"}>

                                <div className="row">
                                    <div className="col-md-12">

                                        <strong>Respuesta</strong> <br />
                                        {bean.StatusDescription}
                                        {bean.StatusMessage &&
                                            <small>{bean.StatusMessage}</small>
                                        }
                                    </div>
                                    <div className="col-md-12">
                                        <strong>Archivo XML</strong> <br />
                                        <a href={document.URL ?? document.URLLink} target='_blank'>{document.Filename ?? document.Name}</a>
                                    </div>
                                    <div className="col-md-12">
                                        <strong>Archivo PDF</strong> <br />
                                        <a href={documentPdf.URL ?? documentPdf.URLLink} target='_blank'>{documentPdf.Media}</a>
                                    </div>
                                </div>
                            </Alert>
                        </div>
                    </div>
                }
            </div>
            {lista.length > 0 &&
                <>
                    <div className="col-md-12">
                        <hr />
                    </div>
                    <div className="col-md-12 mt-2">
                        <label>Lista de Respuestas</label>
                        <table className="table table-striped">
                            <thead className="table-head thead-light">
                                <tr>
                                    {head2.map((col, index) => (
                                        col.visible && <th key={index}>{col.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {lista && lista.length > 0 ? (
                                    lista.map((item, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {head2.map((col, colIndex) => (
                                                col.visible && (
                                                    <td key={colIndex}>
                                                        {item[col.property] !== undefined && item[col.property] !== null
                                                            ? item[col.property]
                                                            : "N/A"}
                                                    </td>
                                                )
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={head2.filter(col => col.visible).length} className="text-center">
                                            No hay datos disponibles
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            }
            {/* <PrintJson json={bean} /> */}
        </div>
    )

}